module.exports = __webpack_public_path__ + "static/media/extended-logo-pw.30efad96.svg";